if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return;
        const variantInput = this.form.querySelector('[name=id]');
        if (variantInput) variantInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('span') || this.submitButton;
        this.form.addEventListener('change', () => this.syncSubmitButtonState());

        if (document.querySelector('cart-drawer') && this.submitButton) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (!this.submitButton) return;
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        const currentVariantId = this.getCurrentVariantId();
        if (currentVariantId && this.form.dataset.puAddedVariantId === currentVariantId) {
          this.openCart();
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const loadingSpinner = this.querySelector('.loading__spinner');
        loadingSpinner?.classList.remove('hidden');
        const shouldOpenCartDrawer =
          this.cart && this.cart.tagName === 'CART-DRAWER' && typeof this.cart.open === 'function';
        if (shouldOpenCartDrawer) {
          this.cart.setActiveElement(document.activeElement);
          this.cart.classList.add('is-updating');
          this.cart.open(this.submitButton);
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            this.form.dataset.puAddedVariantId = String(formData.get('id') || '');
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    if (this.cart && typeof this.cart.renderContents === 'function') {
                      this.refreshHeaderCartIcon(response);
                      this.cart.renderContents(response);
                    } else window.location = window.routes.cart_url;
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              if (this.cart && typeof this.cart.renderContents === 'function') {
                this.refreshHeaderCartIcon(response);
                this.cart.renderContents(response);
              } else window.location = window.routes.cart_url;
            }
            this.syncSubmitButtonState();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (shouldOpenCartDrawer) this.cart.classList.remove('is-updating');
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          loadingSpinner?.classList.add('hidden');
          });
      }

      getCurrentVariantId() {
        return String(this.form?.querySelector('[name="id"]')?.value || '');
      }

      syncSubmitButtonState() {
        if (!this.submitButtonText || !this.submitButton) return;
        const currentVariantId = this.getCurrentVariantId();
        const shouldShowViewCart = currentVariantId && this.form.dataset.puAddedVariantId === currentVariantId;
        this.submitButtonText.textContent = shouldShowViewCart ? 'VIEW CART' : 'ADD TO CART';
      }

      openCart() {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          if (typeof cartDrawer.setActiveElement === 'function') cartDrawer.setActiveElement(this.submitButton);
          cartDrawer.open(this.submitButton);
          return;
        }

        const cartIcon = document.querySelector('#cart-icon-bubble');
        if (cartIcon) {
          cartIcon.click();
          return;
        }

        window.location = window.routes?.cart_url || '/cart';
      }

      refreshHeaderCartIcon(response) {
        const cartIconMarkup = response?.sections?.['cart-icon-bubble'];
        if (!cartIconMarkup) return;

        const nextCartIcon = new DOMParser()
          .parseFromString(cartIconMarkup, 'text/html')
          .getElementById('cart-icon-bubble');
        const currentCartIcon = document.getElementById('cart-icon-bubble');

        if (!nextCartIcon || !currentCartIcon) return;

        currentCartIcon.replaceWith(nextCartIcon);
        if (this.cart && typeof this.cart.setHeaderCartIconAccessibility === 'function') {
          this.cart.setHeaderCartIconAccessibility();
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
